import { render, staticRenderFns } from "./ControlPropertiesActes.vue?vue&type=template&id=4e8973eb&"
import script from "./ControlPropertiesActes.vue?vue&type=script&lang=js&"
export * from "./ControlPropertiesActes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports